// hooks/useAppRoutes.js
import { useLocation } from "react-router-dom";
import useAuthStore from "../../store/auth/auth.js";
import {
  adminRoutes,
  superAdminRoutes,
  unauthenticatedRoutes,
  memberRoutes,
  parentAdminRoutes,
} from "./Routes/Routes.jsx";

const useAppRoutes = (user) => {
  const { isSuperadmin, isAuthenticated } = useAuthStore();
  const location = useLocation();
  let routes = [];

  // Superadmin routes ONLY
  if (isSuperadmin) {
    routes = superAdminRoutes;
  }
  // Admin routes ONLY
  else if (isAuthenticated && user.role === "admin") {
    routes = adminRoutes;
  }
  // Unauthenticated routes
  else if (!isAuthenticated) {
    routes = unauthenticatedRoutes;
  }
  // Member routes
  else if (isAuthenticated) {
    routes = memberRoutes;
  }

  // Add parent admin routes if user has parentAdmin role
  if (
    isAuthenticated &&
    user.userRoles &&
    Object.values(user.userRoles).includes("parentAdmin")
  ) {
    routes = [...routes, ...parentAdminRoutes];
  }

  const pathMatchesRoute = (routePath, currentPath) => {
    if (routePath === currentPath) return true;

    if (routePath.includes(":")) {
      // Convert route pattern to regex pattern
      const pattern = routePath
        // Match optional params: /:param? -> optional segment
        .split("/")
        .map((segment) => {
          if (segment.endsWith("?")) {
            // Optional param
            return "(\\/[^\\/]+)?";
          } else if (segment.startsWith(":")) {
            // Required param
            return "\\/[^\\/]+";
          } else if (segment) {
            // Static segment
            return "\\/" + segment;
          }
          return "";
        })
        .join("");

      const regex = new RegExp(`^${pattern}$`);
      return regex.test(currentPath);
    }

    return false;
  };

  const isPathInRoutes = (path, routeArray) => {
    return routeArray.some((route) => {
      if (pathMatchesRoute(route.path, path)) return true;
      if (route.children) {
        return route.children.some((child) => {
          const fullPath = `${route.path}${child.path}`.replace("//", "/");
          return pathMatchesRoute(fullPath, path);
        });
      }
      return false;
    });
  };

  const currentPath = location.pathname;
  const isValidRoute = isPathInRoutes(currentPath, routes);

  return { routes, isValidRoute };
};

export default useAppRoutes;
